<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M10 15.8929C13.2546 15.8929 15.8929 13.2546 15.8929 10C15.8929 6.7455 13.2546 4.10718 10 4.10718C6.7455 4.10718 4.10718 6.7455 4.10718 10C4.10718 13.2546 6.7455 15.8929 10 15.8929Z" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M10.0004 7.05369V6.39893M10.0004 12.9465V13.6013M11.31 8.03583C10.6552 6.72631 8.36353 7.08795 8.36353 8.54509C8.36353 10.4416 11.6373 9.55023 11.6373 11.4052C11.6373 12.875 9.01829 13.2739 8.36353 11.9644" 
    stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'BountyPayoutIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>